import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import axios from "axios";
import { translations } from "./translations";
import { IMAGES } from "../constants/site";

const LanguageContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getPath = (obj, path) => path.split(".").reduce((o, k) => (o == null ? o : o[k]), obj);

const applyOverrides = (base, overrides = {}) => {
  const out = structuredClone(base);
  Object.entries(overrides).forEach(([path, value]) => {
    const keys = path.split(".");
    const parent = keys.slice(0, -1).reduce((o, k) => o?.[k], out);
    if (parent && value !== "" && value != null) parent[keys[keys.length - 1]] = value;
  });
  return out;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "de";
    return window.localStorage.getItem("aw_lang") || "de";
  });
  const [settings, setSettings] = useState({ texts: {}, images: {} });

  useEffect(() => {
    window.localStorage.setItem("aw_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    axios.get(`${API}/site/settings`).then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const t = useMemo(() => applyOverrides(translations[lang], settings.texts?.[lang]), [lang, settings]);
  const images = useMemo(() => {
    const custom = Object.fromEntries(Object.entries(settings.images || {}).filter(([, v]) => v));
    return { ...IMAGES, ...custom };
  }, [settings]);

  const toggleLang = () => setLang((prev) => (prev === "de" ? "en" : "de"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t, images }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
